import React from 'react'
import DataPictureTitles from "./DataPictureTitles"
import Images from "./Images"
import "./dataPicture.css"
import { useAuth0 } from "@auth0/auth0-react"

export default function DataPicture({apiData, localData, state, section}) {
  
  const {user} = useAuth0();

  let className = "data__picture title"
  if(!section) className = className + " orange-border"
  if(section === 1) {
      className = className + " yellow-border"
    }
  if (localData.user) apiData.sprites.other.dream_world.front_default = user.picture

  return (
    <div className={className}>
      <DataPictureTitles localData={localData}/>
        <div className="data__picture--imgcontainer">
          <div className="flex-pokemon-container">
            <Images src={apiData?.sprites?.other?.dream_world?.front_default} state={state}/>
          </div>
          <div className="flex-pokeball-container">
            <Images src={"pokeball"}/>
          </div>  
        </div>
    </div>
  )
}
